type EnvProps = {
  COOKIE_DOMAIN?: string | null;
  JWT_COOKIE_KEY?: string | null;
  GOOGLE_MAPS_API_URL?: string | null;
  CLIENT_API_BASE?: string | null;
  LOGO_DEV_BASE_URL?: string | null;
  LOGO_DEV_PUBLISHABLE_KEY?: string | null;
  S3_PUBLIC_BASE_URL?: string | null;
  S3_PUBLIC_FILE_BUCKET?: string | null;
  ENABLE_SUGGESTIONS?: string | boolean | null;
  TYPING_DEBOUNCE?: string | number | null;
  ENABLE_CALENDAR_EVENTS_TODAY?: string | boolean | null;
  SUPPRESS_GRID_ROW_VIRTUALIZATION?: string | null;
};

const env: EnvProps = {
  COOKIE_DOMAIN: null,
  JWT_COOKIE_KEY: null,
  GOOGLE_MAPS_API_URL: null,
  CLIENT_API_BASE: null,
  LOGO_DEV_BASE_URL: null,
  LOGO_DEV_PUBLISHABLE_KEY: null,
  S3_PUBLIC_BASE_URL: null,
  S3_PUBLIC_FILE_BUCKET: null,
  ENABLE_SUGGESTIONS: null,
  TYPING_DEBOUNCE: null,
  ENABLE_CALENDAR_EVENTS_TODAY: null,
  SUPPRESS_GRID_ROW_VIRTUALIZATION: null,
};

const envKeys = Object.keys(env) as Array<keyof EnvProps>;

export const DesignSysEnvUtil = {
  initialize(data: EnvProps) {
    envKeys.forEach(key => {
      const value = data[key];
      if (value !== null && value !== undefined) {
        (env as Record<keyof EnvProps, EnvProps[keyof EnvProps]>)[key] = value;
      }
    });
  },
  get suppressGridRowVirtualization() {
    return env.SUPPRESS_GRID_ROW_VIRTUALIZATION === 'true';
  },
  get typingDebounce() {
    const defaultDebounce = 200;

    if (typeof env.TYPING_DEBOUNCE === 'number') {
      return env.TYPING_DEBOUNCE;
    }

    if (typeof env.TYPING_DEBOUNCE === 'string') {
      const parsed = Number.parseInt(env.TYPING_DEBOUNCE, 10);
      return Number.isNaN(parsed) ? defaultDebounce : parsed;
    }

    return defaultDebounce;
  },
  get cookieDomain() {
    return env.COOKIE_DOMAIN;
  },
  get userCookieName() {
    return env.JWT_COOKIE_KEY;
  },
  get googleMapsApi() {
    return env.GOOGLE_MAPS_API_URL;
  },
  get clientApiBase() {
    return env.CLIENT_API_BASE || '/api';
  },
  get logoDevBaseUrl() {
    return env.LOGO_DEV_BASE_URL;
  },
  get logoDevPublishableKey() {
    return env.LOGO_DEV_PUBLISHABLE_KEY;
  },
  get publicBaseUrlS3() {
    return env.S3_PUBLIC_BASE_URL;
  },
  get publicS3Bucket() {
    return env.S3_PUBLIC_FILE_BUCKET;
  },
  get enableSuggestions() {
    return env.ENABLE_SUGGESTIONS === 'true' || env.ENABLE_SUGGESTIONS === true;
  },
  get enableCalendarEventsToday() {
    return (
      env.ENABLE_CALENDAR_EVENTS_TODAY === 'true' ||
      env.ENABLE_CALENDAR_EVENTS_TODAY === true
    );
  },
};
